// extracted by mini-css-extract-plugin
module.exports = {"widget":"_d7a3830","arrow":"_0308b4f","link":"_df696b8"};